export default __webpack_public_path__ + "static/media/status-bg1.621219dd.png";